import React, { useEffect, useState, useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { Form, Input, Select as SelectAntd, Spin } from 'antd';
import { useSnackbar } from 'notistack';
import ButtonComponent from '@components/Shared/Buttons/Button';
import useDebounce from '@hooks/useDebounce';
import { TitlePage } from '@src/@styles/styles.global';
import Services, { IFormaContribuicao, IEstrategias,IDoacao, IPessoa } from './services';
import { IPerfil } from '@interfaces/UserComplete';
import { MaskCPFeCNPJ, isReal, ClearString } from '@utils/Masks';
import Tag from '@src/components/Shared/Tag';
import { addDays } from 'date-fns';
import { useLoading } from '@hooks/LoadingContext';
import { useParams } from 'react-router-dom';

import {
  ChevronRight,
  Close,
  DoneOutlined,
  SaveOutlined,
  Receipt,
} from '@material-ui/icons';

import { useAuth } from '@hooks/AuthenticateContext';

interface IProps {
  nextStep: Function;
}
const DATAMAX = addDays(new Date(), 0).toISOString().split('T')[0];
const DATAMIN = addDays(new Date(), -45507).toISOString().split('T')[0];
let dataDoacao: string;

const optionsFilter = ['ID', 'CPF/CNPJ'];
const InsercaoDoacoes: React.FC<IProps> = ({ nextStep }) => {
  const { removeLoading, setValues } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const { idDoacao}: { idDoacao: string;} = useParams();

  const [data, setData] = useState<IPessoa[]>([]);

  const [formRef] = Form.useForm();
  const [formasContruibuicao, setFormasContribuicao] = useState<
    IFormaContribuicao[]
  >([]);
  const [estrategias, setEstrategias] = useState<IEstrategias[]>([]);
  const [perfis, setPerfis] = useState<IPerfil[]>([]);
  const [loadingFinish, setLoadingFinish] = useState(false);
  const [loadingTipoPerfil, setLoadingTipoPerfil] = useState(false);
  const [loadingDoacao, setLoadingDoacao] = useState(false);
  const [loading, setLoading] = useState(false);

  const [perfil, setPerfil] = useState('');
  const [valor, setValor] = useState('');

  const [totalPages, setTotalPages] = useState(0);
  const [totalItens, setTotalItems] = useState(0);
  const [viewConfirmation, setViewConfirmation] = useState(false);
  const [viewConfirmation2, setViewConfirmation2] = useState(false);
  const [botaoRebibo, setBotaoRecibo] = useState(false);
  const [valorModify, setValorModify] = useState<string>(valor);
  const [selectedFilter, setSelectedFilter] = useState(
    optionsFilter[optionsFilter.length - 1],
  );
  const [stateConfirme, setStateConfirme] = useState({
    CPF: '',
    tipoPerfil: '',
    Nome: '',
    Valor: '',
    DataDoacao: '',
    observacao: '',
  });
  const [confirme, setConfirme] = useState(false);

  const [respostaErroBuscaPerfil, setRespostaErroBuscaPerfil] = useState('');
  const handleSelectFilter = (value: string) => {
    setSelectedFilter(value);
    formRef.setFieldsValue({
      tipo_perfil: undefined,
    });
    setPerfis([]);
  };
  const loadFormasContribuicao = async () => {
    const service = new Services();
    const { error, response } = await service.loadFormaContribuicao();
    if (!error && response) {
      setFormasContribuicao(response);
    }
    removeLoading();
  };
  const loadEstrategias = async () => {
    setValues(true);
    const service = new Services();
    console.log(selectedFilter);
    const { error, response } = await service.loadEstrategias();
    if (!error && response) {
      setEstrategias(response);
    }
  };
  const getPessoaByDocumento = async (documento: string) => {
    setRespostaErroBuscaPerfil('');
    setLoadingTipoPerfil(true);
    const service = new Services();
    const { error, response } = await service.getPessoaByDocumento(documento);
    if (!error && response) {
      setPerfis(response.pessoa.perfis);
      if (response.pessoa.perfis.length <= 0) {
        setRespostaErroBuscaPerfil(
          'Não existe uma pessoa cadastrada para este CPF/CNPJ',
        );
      }
      if (!error && response) {
        setStateConfirme({
          Nome: response.pessoa.nome,
          CPF: response.pessoa.documento,
          DataDoacao: '',
          Valor: '',
          tipoPerfil: '',
          observacao: '',
        });
        setPerfis(response.pessoa.perfis);
        setViewConfirmation2(true);
      }
    }else {
      setViewConfirmation2(false);
      setRespostaErroBuscaPerfil(
        'Não existe uma pessoa cadastrada para este CPF/CNPJ',
      );
    }
    setLoadingTipoPerfil(false);
    havePerfil();
  };
  const getPessoaByID = async (id: number) => {
    setRespostaErroBuscaPerfil('');
    setLoadingTipoPerfil(true);
    const service = new Services();
    const { error, response } = await service.getPessoaByID(id);
    if (!error && response) {
      setPerfis(response.pessoa.perfis);
      if (response.pessoa.perfis.length <= 0) {
        setRespostaErroBuscaPerfil(
          'Não existe perfil cadastrado para este ID',
        );
      }
      if (!error && response) {
        setStateConfirme({
          Nome: response.pessoa.nome,
          CPF:
            response.pessoa.documento !== null
              ? MaskCPFeCNPJ(response.pessoa.documento).valueModify
              : '',
          DataDoacao: '',
          Valor: '',
          tipoPerfil: '',
          observacao: '',
        });
        setPerfis(response.pessoa.perfis);
        setViewConfirmation2(true);
      }
    } else {
      setViewConfirmation2(false);
      setRespostaErroBuscaPerfil(
        'Não existe perfil cadastrado para este ID',
      );
    }
    setLoadingTipoPerfil(false);
    havePerfil();
  };
  const debounceOnChange = (value: string) => {
    formRef.setFieldsValue({
      tipo_perfil: undefined,
    });
    setPerfis([]);
    if (selectedFilter === 'CPF/CNPJ') {
      debounceGetPessoaByDocumento(value);
    } else if (selectedFilter === 'ID') {
      debounceGetPessoaByID(parseInt(value));
    }
  };
  const havePerfil = () => {
    if (perfis.length >= 0) {
      if (nextStep) {
        nextStep();
      }
    }
  };
  const debounceGetPessoaByDocumento = useDebounce(getPessoaByDocumento, 1000);
  const debounceGetPessoaByID = useDebounce(getPessoaByID, 600);


  const loadDoacao= useCallback(async idDoacao => {
    setLoadingDoacao(true);
    const services = new Services();
    const { error, response } = await services.GetPegaInfosDoacao(idDoacao);

    if (!error && response) {

      //dataDoacao = (response.data_doacao).split('/').reverse().join('-');

      dataDoacao = new Date(response.data_doacao).toISOString().substr(0, 10);

      const doacao: IDoacao = {
        id: response.id,
        perfil_id: response.perfil_id,
        perfil_tipo: response.perfil_tipo,
        data_doacao: response.data_cadastro,
        data_cadastro: response.data_cadastro,
        valor_doacao: response?.valor_doacao,
        observacao: response.observacao,
        estrategia_id: response.estrategia_id,
        estrategia_descricao: response.estrategia_descricao,
        origem_doacao_id: response.origem_doacao_id,
        origem_doacao_descricao: response.origem_doacao_descricao,
        doador_id: response.doador_id,
        doador_nome: response.doador_nome,
      };

      setPerfil(response.perfil_id)
      setValorModify(Intl.NumberFormat('pt-br', {
        style: 'currency',
        currency: 'BRL',
      })
        .format(response.valor_doacao)
        .replace('R$', '')
        .trim() || '',)

      formRef.setFieldsValue({
        id: response.id,
        perfil_id: response.perfil_id,
        perfil_tipo: response.perfil_tipo,
        data_doacao: dataDoacao,
        valor_doacao: Intl.NumberFormat('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
          .format(response.valor_doacao)
          .replace('R$', '')
          .trim() || '',
        observacao: response.observacao,
        estrategia_id: response.estrategia_id,
        origem_doacao_id: response.origem_doacao_id,
        tipo_perfil: response.perfil_tipo,
        doador_id: response.doador_id,
        doador_nome: response.doador_nome,

      });
      setLoadingDoacao(false);

    } else {
      console.log('error', error);
    }
    onChangeSubmit();

  }, []);

  const setValuesOrError = (error: boolean, response: any) => {
    if (!error && response) {
      setTotalItems(response.total_itens);
      setTotalPages(response.total_pagina);
      setData(response.pessoas);
      setLoadingDoacao(false);
    } else {
      //enqueueSnackbar('Ocorreu um erro.', {
       // variant: 'error',
       // anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      //});
      setLoadingDoacao(false);
    }
  };


  async function onChangeSubmit(){
    setLoadingDoacao(true);

    let data = {
      id: 0,
      sara_id: 0,
      id_perfil: Number(perfil),
      nome: '',
      cpf: '',
      email: '',
      telefone: '',
      page_number: 1,
      page_size: 10,
    };

    const services = new Services();
    const { error, response } = await services.loadPessoas({
      data,
    });
    setValuesOrError(error, response);
  }

  useEffect(() => {
    loadDoacao(idDoacao);
    loadEstrategias();
    loadFormasContribuicao();
    window.document.title = 'CRM - Edição de Doações';
  }, []);

  const [doacaoId, setdoacaoId] = useState<number | null>(null);

const onFinish = async (values: any) => {
  if (!confirme) {
    setStateConfirme({
      DataDoacao: values.data_doacao,
      Valor: values.valor,
      tipoPerfil: values.tipo_perfil,
      CPF: stateConfirme.CPF,
      Nome: stateConfirme.Nome,
      observacao: values.observacao,
    });
    setViewConfirmation(true);
    if (nextStep) nextStep();
    return;
  }
  if (nextStep) nextStep();
  setLoadingFinish(true);
  const service = new Services();
  const { error, doacaoId: retornodoacaoId } = await service.inserirDoacao({
    doacaoId: Number(idDoacao),
    estrategiaId: values.estrategia_id,
    origemDoacaoId: values.origem_doacao_id,
    perfilId: perfil,
    valorDoacao: ClearString(valorModify) / 100,
    dataDoacao: values.data_doacao,
    observacao: values.observacao,
  });

  setLoadingFinish(false);
  if (!error) {
    //setdoacaoId(retornodoacaoId); // salvando o idDaDoacao
    setViewConfirmation(false);
    setConfirme(false);
    setBotaoRecibo(true);
    enqueueSnackbar(`Inserção feita com sucesso`, {
      variant: 'success',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
  } else {
    enqueueSnackbar(`Ocorreu um erro`, {
      title: 'Ocorreu um erro ',
      variant: 'error',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
  }
};

  return (
    <Grid container style={{ padding: 10 }}>
      {/* // HEADER PAGE */}
      <Grid container alignItems="center" justify="flex-start">
        <Grid container item lg={12}>
          <Grid item lg={12} xs={12}>
            <TitlePage style={{ margin: 10, paddingTop: 6 }}>
              Edição da doação
            </TitlePage>
          </Grid>
          <Grid item lg={2} xs={12}>
            <Tag color="default"> Doação individual </Tag>
          </Grid>

          <Grid item lg={4} xs={12} style={{marginLeft: 150, paddingTop: 5}}>
              <ButtonComponent
                color="primary"
                disabled={botaoRebibo !== true || !idDoacao}
                onClick={async () => {
                  if (!idDoacao) return;

                  const service = new Services();
                  const { error, response } = await service.gerarRecibo(Number(idDoacao));

                  if (!error && response instanceof Blob) {
                    const fileURL = URL.createObjectURL(response);
                    const link = document.createElement('a');
                    link.href = fileURL;

                    const contentDisposition = response.type;
                    const fileName = `Recibo_Doacao_${doacaoId}.pdf`;

                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    URL.revokeObjectURL(fileURL);

                    enqueueSnackbar('Recibo baixado com sucesso', {
                      variant: 'success',
                      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
                    });
                       window.close();
                  } else {
                    enqueueSnackbar('Erro ao gerar recibo', {
                      variant: 'error',
                      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
                    });
                  }
                }}
              >
                <Receipt style={{ marginRight: 10 }} /> Gerar recibo
              </ButtonComponent>
            </Grid>
        </Grid>
      </Grid>
      {/* // HEADER PAGE */}
      <Grid container item lg={12} xs={12} style={{}}>

      <Grid container item lg={5} xs={12} style={{}}>
        <Spin spinning={loadingFinish}>
          <Form
            form={formRef}
            size="middle"
            layout="vertical"
            scrollToFirstError={true}
            onFinish={onFinish}
            labelAlign="left"
            requiredMark={false}
          >
            <Grid container>
              <Grid
                item
                lg={6}
                xs={12}
                id="page-inserir-doacoes-step1"
                style={{ padding: 10, paddingBottom: 0, paddingLeft: 0 }}
              >
                <Form.Item
                  name="data_doacao"
                  label="Data de doação"
                  //hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Selecione a data de doação',
                    },
                  ]}
                  style={{ paddingTop: 0 }}
                >
                  <Input
                    type="date"
                    onChange={() => {
                      if (nextStep) nextStep();
                    }}
                    max={DATAMAX}
                    min={DATAMIN}
                  />
                </Form.Item>
              </Grid>
              <Grid
                item
                lg={6}
                xs={12}
                id="page-inserir-doacoes-step2"
                style={{ padding: 10, paddingBottom: 0, paddingLeft: 0 }}
              >
                <Form.Item
                  name="origem_doacao_id"
                  label="Origem de doação"
                  //hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Selecione uma origem de doação',
                    },
                  ]}
                >
                  <SelectAntd
                    placeholder="Origem de doação"
                    onChange={() => {
                      if (nextStep) nextStep();
                    }}
                  >
                    {formasContruibuicao.map(item => (
                      <SelectAntd.Option key={item.id} value={item.id}>
                        {item.descricao}
                      </SelectAntd.Option>
                    ))}
                  </SelectAntd>
                </Form.Item>
              </Grid>
              <Grid
                item
                lg={12}
                xs={12}
                id="page-inserir-doacoes-step3"
                style={{ padding: 10, paddingBottom: 0, paddingLeft: 0 }}
              >
                <Form.Item
                  name="estrategia_id"
                  label="Estratégia"
                  //hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Selecione uma Estratégia',
                    },
                  ]}
                >
                  <SelectAntd
                    placeholder="Estratégia"
                    onChange={() => {
                      if (nextStep) nextStep();
                    }}
                  >
                    {estrategias.map((item, index) => (
                      <SelectAntd.Option key={index} value={item.id}>
                        {item.nome}
                      </SelectAntd.Option>
                    ))}
                  </SelectAntd>
                </Form.Item>
              </Grid>
              <Spin spinning={loadingTipoPerfil} tip="Buscando perfil">
                <Grid container>
                  <Grid
                    item
                    md={3}
                    lg={3}
                    xs={12}
                    style={{ padding: 10, paddingBottom: 0, paddingLeft: 0 }}
                    id="page-inserir-doacoes-step4"
                  >

                    <Form.Item
                      name="doador_id"
                      label="ID"
                      //hasFeedback

                      style={{ paddingTop: 0 }}
                    >
                      <Input
                      disabled
                        //defaultValue={'4373'}
                      />
                    </Form.Item>
                  </Grid>
                  <Grid
                    item
                    md={9}
                    lg={9}
                    xs={12}
                    id="page-inserir-doacoes-step5"
                    style={{ padding: 10, paddingBottom: 0, paddingLeft: 0 }}
                  >
                   <Form.Item
                      name="doador_nome"
                      label="Nome cadastro"
                      //hasFeedback

                      style={{ paddingTop: 0 }}
                    >
                      <Input
                      disabled
                      //defaultValue={'ANGELA CRISTINA DO NASCIMENTO SANTOS'}
                      />
                    </Form.Item>
                  </Grid>

                  <Grid
                    item
                    lg={6}
                    xs={12}
                    id="page-inserir-doacoes-step6"
                    style={{ padding: 10, paddingBottom: 0, paddingLeft: 0 }}
                  >
                    <Form.Item
                      name="tipo_perfil"
                      label="Tipo de perfil"
                      //hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Selecione um perfil',
                        },
                      ]}
                      style={{ paddingTop: 0 }}
                    >
                      <SelectAntd
                        disabled={perfis.length <= 0}
                        placeholder="Tipo de perfil"
                        onChange={() => {
                          if (nextStep) nextStep();
                        }}
                      >
                        {/*perfis.map((item, index) => (
                          <SelectAntd.Option key={index} value={item.perfil_id}>
                            {item.tipo_perfil_descricao}
                          </SelectAntd.Option>
                        ))}*/}
                      </SelectAntd>
                    </Form.Item>
                  </Grid>
                  <Grid
                    item
                    lg={3}
                    xs={12}
                    id="page-inserir-doacoes-step7"
                    style={{ padding: 10, paddingBottom: 0, paddingLeft: 0 }}
                  >
                    <Form.Item
                      name="valor_doacao"
                      label="Valor"
                      //hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Digite um valor',
                        },
                        {
                         // pattern: /^[1-9][0-9]{0,5}$/,
                         // message: 'Digite um valor maior que R$ 0,00',
                        },
                      ]}
                      style={{ paddingTop: 0 }}
                    >
                      <Input
                        onChange={(e: any) => {
                          formRef.setFieldsValue({
                            valor_doacao: isReal(e.target.value),
                          });
                          setValorModify(e.target.value);
                        }}
                      />
                    </Form.Item>
                  </Grid>

                  <Grid
                    item
                    lg={12}
                    xs={12}
                    id="page-inserir-doacoes-step8"
                    style={{ padding: 10, paddingBottom: 0, paddingLeft: 0 }}
                  >
                    <Form.Item
                      name="observacao"
                      label="Observação"
                      //hasFeedback

                      style={{ paddingTop: 0 }}
                    >
                      <Input

                      />
                    </Form.Item>
                  </Grid>
                  <Grid
              item
              lg={4}
              xs={12}
              sm={12}
              style={{ paddingTop: 10, marginRight: 10 }}
            >
              <ButtonComponent
                color="primary"
                onClick={() => {
                  setConfirme(true);
                  formRef.submit();
                  if (nextStep) nextStep();
                }}
                fullWidth
              >
                <SaveOutlined style={{ marginRight: 10 }} /> Confirmar
              </ButtonComponent>
            </Grid>
            <Grid item lg={4} xs={12} sm={12} style={{ paddingTop: 10 }}>
              <ButtonComponent
                color="default"
                onClick={() => {
                  setConfirme(false);
                  setViewConfirmation(false);
                  if (nextStep) nextStep();
                }}
                fullWidth
              >
                <Close style={{ marginRight: 10 }} /> Cancelar
              </ButtonComponent>
            </Grid>




                </Grid>
              </Spin>
            </Grid>
          </Form>
        </Spin>
        </Grid>





      </Grid>

    </Grid>
  );
};

export default InsercaoDoacoes;
